<template>
  <div class="hall-bg">
    <div class="hall-content">
      <aside class="sidebar">
        <div class="sidebar-title">笔记分类</div>
        <ul class="sidebar-list">
          <li :class="{active: currentTab==='curtis'}" @click="currentTab='curtis'">丹尼斯笔记</li>
          <li :class="{active: currentTab==='user'}" @click="currentTab='user'">龟谷笔记</li>
          <li :class="{active: currentTab==='circle'}" @click="currentTab='circle'">龟谷圈</li>
        </ul>
      </aside>
      <main class="main-list">
        <div v-if="currentTab==='curtis'">
          <div class="note-list" v-if="curtisNotes.length > 0">
            <div class="note-item" v-for="(item, idx) in curtisNotes" :key="'curtis-'+idx">



              <div class="note-date">
                <div class="day">{{ item.day }}/</div>
                <div class="month-year">
                  <div class="month">{{ item.month }}月</div>
                  <div class="year">{{ item.year }}</div>
                </div>
              </div>


              <div class="note-content">
                <div class="note-title">{{ item.title }}</div>

                <span class="meta-view">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 3C4 3 1.333 8 1.333 8C1.333 8 4 13 8 13C12 13 14.667 8 14.667 8C14.667 8 12 3 8 3Z" stroke="#B3B3B3" stroke-width="1.2"/>
                      <circle cx="8" cy="8" r="2.2" stroke="#B3B3B3" stroke-width="1.2"/>
                    </svg> {{ item.views }}</span>

                <div class="note-desc" v-html="item.desc"></div>
                <div class="note-meta">
                  <span class="meta-link" @click="goDetail(item.id,currentTab)">查看详情 &gt;</span>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">
            <p>暂无丹尼斯笔记数据</p>
          </div>
        </div>
        <div v-else-if="currentTab==='user'">
          <div style="text-align:right;margin-bottom:18px;"><button class="publish-btn" @click="$router.push('/note-edit')">发布</button></div>
          <div class="note-list" v-if="userNotes.length > 0">
            <div class="note-item" v-for="(item, idx) in userNotes" :key="'user-'+idx">

              <div class="note-date">
                <div class="day">{{ item.day }}/</div>
                <div class="month-year">
                  <div class="month">{{ item.month }}月</div>
                  <div class="year">{{ item.year }}</div>
                </div>
              </div>

              <div class="note-content">
                <div class="note-title">{{ item.title }}</div>
                <span class="meta-view">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 3C4 3 1.333 8 1.333 8C1.333 8 4 13 8 13C12 13 14.667 8 14.667 8C14.667 8 12 3 8 3Z" stroke="#B3B3B3" stroke-width="1.2"/>
                    <circle cx="8" cy="8" r="2.2" stroke="#B3B3B3" stroke-width="1.2"/>
                  </svg> {{ item.views }}</span>
                <div class="note-desc" v-html="item.desc"></div>
                <div class="note-meta">
                  <span class="meta-link" @click="goDetail(item.id,currentTab)">查看详情 &gt;</span>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">
            <p>暂无龟谷笔记数据</p>
          </div>
        </div>
        <div v-else-if="currentTab==='circle'">
          <div class="note-list" v-if="circleNotes.length > 0">
            <div class="note-item" v-for="(item, idx) in circleNotes" :key="'circle-'+idx">


              <div class="note-date">
                <div class="day">{{ item.day }}/</div>
                <div class="month-year">
                  <div class="month">{{ item.month }}月</div>
                  <div class="year">{{ item.year }}</div>
                </div>
              </div>

              <div class="note-content">
                <div class="note-title">{{ item.title }}</div>

                <span class="meta-view">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M8 3C4 3 1.333 8 1.333 8C1.333 8 4 13 8 13C12 13 14.667 8 14.667 8C14.667 8 12 3 8 3Z" stroke="#B3B3B3" stroke-width="1.2"/>
                      <circle cx="8" cy="8" r="2.2" stroke="#B3B3B3" stroke-width="1.2"/>
                    </svg> {{ item.views }}</span>

                <div class="note-desc" v-html="item.desc"></div>
                <div class="note-meta">
                  <span class="meta-link" @click="goDetail(item.id,currentTab)">查看详情 &gt;</span>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state">
            <p>暂无龟谷圈数据</p>
          </div>
        </div>
        <div class="pagination-wrapper" v-if="total > 0">
          <MyPagination 
            :total="total" 
            v-model:page="page" 
            v-model:limit="limit" 
            @pagination="onPagination" 
          />
        </div>
      </main>
      
    </div>
    <footer class="footer">
      <div class="footer-main">
        <div class="footer-logo">龟谷</div>
        <div class="footer-info">
          <div>联系方式<br>18878399268<br>19042619917<br>415426316@qq.com</div>
          <!-- <div>联系方式<br>400-001-0192<br>info@haiguicp.com</div> -->
          <div>公司官网<br><a href="http://whhgfx.com" style="color: white; text-decoration: none;" target="_blank">whhgfx.com</a></div>
          <div>线下交流<br>
            <img src="@/assets/weixin1.jpg" alt="微信二维码1" class="qr" />
            <img src="@/assets/weixin2.jpg" alt="微信二维码2" class="qr" />
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        Copyrights © 2025 by ultanova.All Rights Reserved.
        <a href="http://whhgfx.com" style="color:#bbb; text-decoration: none;" target="_blank">whhgfx.com </a>
        黔ICP备2025056779号
        <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color:#bbb; text-decoration: none;" target="_blank">
          <img src="@/assets/警徽.png" alt="公安部网络安全保卫局警徽" style="width: 15px; height: 15px; vertical-align: middle;">
          京公网安备 11010102000001号</a>
      </div>
    </footer>
    <router-view />
  </div>
</template>

<script setup>
import { queryData } from '@/api/articles'
import { userInfo } from '@/composables/useAuth'
import { ref, defineOptions,onMounted,watch  } from 'vue'
import { useRouter } from 'vue-router'
import moment from 'moment'
import MyPagination from '@/components/MyPagination/MyPagination.vue'
defineOptions({ name: 'HallPage' })

const router = useRouter()

const currentTab = ref('curtis')
const pageNum = ref(1)
const pageSize = ref(8)
const total = ref(0)

const curtisNotes = ref([])

const userNotes = ref([])

const circleNotes = ref([])

async function loadData() {
  const userId = userInfo?.value?.userId || userInfo?.value?.id
  try {
    const res= await queryData(userId,currentTab.value, pageNum.value, pageSize.value)
    if (res.code === 200) {
      const backendRows = res.rows; // 后端返回的 HgArticlesAdmin 列表
      total.value = Number(res.total || res.count || 0)
      const formattedNotes = backendRows.map(item => {
        // 解析时间（假设 item.createTime 是 '2025-08-19' 格式）
        const [year, month, day]= moment(item.createdDate).format('YYYY-MM-DD').split('-');
        console.log(moment(item.createdDate).format('YYYY-MM-DD').split('-'))
        // const [year, month, day] = item.createdDate.split('-');
        return {
          id: item.id,
          day,
          month,
          year,
          title: item.title,
          desc: item.summary, // 假设后端 content 对应前端 desc
          views: item.views, // 转为字符串，匹配前端格式
        };
      });
      switch(currentTab.value){
        case 'curtis':
          curtisNotes.value = formattedNotes;
          break;
        case 'user':
          userNotes.value=formattedNotes;
          break;
        case 'circle':
          circleNotes.value=formattedNotes;
          break;
        default:

      }
      
    }
  } catch (e) {
    console.error('加载数据失败:', e)
  }
}

onMounted(loadData)
watch(currentTab, ()=>{
  pageNum.value = 1
  loadData()
})


function goDetail(id,currentTab){
  if(!id){
    console.warn('文章ID不存在，无法跳转到详情页')
    return
  }
  router.push({ path: `/note-detail/${id}/${currentTab}`})
}

function onPagination({ page: p, limit: l }){
  pageNum.value = p
  pageSize.value = l
  loadData()
}
</script>

<style scoped>
.hall-bg {
  min-height: 100vh;
  background: linear-gradient(120deg, #f6fbff 60%, #e6f0ff 100%);
  display: flex;
  flex-direction: column;
}
.navbar {
  position: relative;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 48px;
  background: rgba(10, 24, 60, 0.85);
  z-index: 10;
  box-sizing: border-box;
}
.logo {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1.5px;
  margin-left: 100px; 
}
.nav-links {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-right: 100px;
}
.nav-links li {
  margin-left: 18px;
}
.nav-links a {
  color: #fff;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.2s;
}
.nav-links a.active,
.nav-links a.router-link-exact-active {
  color: #00e0ff;
  font-weight: bold;
}
.nav-links a:hover {
  color: #00e0ff;
}
.auth-links {
  display: flex;
  align-items: center;
}
.divider {
  margin: 0 6px;
  color: #fff;
}
.hall-content {
  display: flex;
  max-width: 1200px;
  margin: 28px auto 0 auto;
  flex: 1;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  min-height: 400px;
}
.sidebar {
  width: 140px;
  background: #f6fbff;
  border-radius: 12px 0 0 12px;
  padding: 18px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sidebar-title {
  font-size: 15px;
  color: #258aff;
  font-weight: bold;
  margin-bottom: 10px;
}
.sidebar-list {
  list-style: none;
  padding: 0;
  width: 100%;
}
.sidebar-list li {
  padding: 8px 0 8px 18px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: background 0.2s, border 0.2s;
}
.sidebar-list .active {
  background: #e6f0ff;
  color: #258aff;
  border-left: 3px solid #258aff;
  font-weight: bold;
}
.main-list {
  flex: 1;
  padding: 18px 12px 18px 12px;
}
.note-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.note-item {
  display: flex;
  background: #f8fbff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.03);
  padding: 18px 24px;
  align-items: center;
}



.note-date {
  display: flex;
  align-items: center;
  width: 90px;
  margin-right: 24px;
  flex-shrink: 0;
  padding: 25px; /* 内边距 */
  background-color: white; /* 背景颜色 */
}

.day {
  font-size: 3.1rem;
  line-height: 1;
  color: #1e3c72; /* 天数文字颜色 */
  margin-right: 5px; /* 调整天数与月份、年份之间的间距 */
}

.month-year {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.month {
  font-size: 1.1rem;
  color: #bbb; /* 月份文字颜色 */
}

.year {
  font-size: 1.1rem;
  color: #bbb; /* 年份文字颜色 */
}



.note-content {
  flex: 1;
  border-left: #bbb 2px solid;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  padding-left: 18px;
}
.note-title {
  font-size: 1.55rem;
  font-weight: bold;
  color: #222;
  text-align: left;
}
.note-desc {
  color: #666;
  font-size: 1.1rem;
  text-align: left;
  line-height: 1;
}
.note-meta {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 14px;
  color: #888;
}
.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding: 0 16px;
}
.meta-link {
  color: #258aff;
  cursor: pointer;
}
.meta-link:hover {
  text-decoration: underline;
}
.meta-view {
  display: flex;
  position: absolute;
  top: 5px;
  right: 5px;
  align-items: center;
  gap: 2px;
}
.footer {
  background: #0a183c;
  color: #fff;
  padding: 10px 0 0 0;
  text-align: center;
  font-size: 12px;
  margin-top: 12px;
}
.footer-main {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-bottom: 6px;
}
.footer-logo {
  font-size: 16px;
  font-weight: bold;
}
.footer-info {
  display: flex;
  gap: 18px;
}
.footer-info div {
  line-height: 1.6;
}
.qr {
  width: 48px;
  margin: 4px 12px 0 0; /* 与下一张图保持间距 */
  display: inline-block;
}
.footer-bottom {
  margin-top: 2px;
  color: #bbb;
}
.publish-btn {
  background: #258aff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 22px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 8px;
  transition: background 0.2s;
}
.publish-btn:hover {
  background: #00e0ff;
  color: #0a183c;
}
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 16px;
}
.empty-state p {
  margin: 0;
}
@media (max-width: 1200px) {
  .hall-content, .footer-main {
    max-width: 100%;
    padding-left: 2vw;
    padding-right: 2vw;
  }
}
@media (max-width: 900px) {
  .hall-content {
    flex-direction: column;
    min-width: 0;
    padding: 0;
  }
  .sidebar {
    width: 100%;
    border-radius: 12px 12px 0 0;
    flex-direction: row;
    justify-content: center;
    padding: 8px 0 0 0;
  }
  .sidebar-list {
    display: flex;
    flex-direction: row;
    width: auto;
    gap: 18px;
  }
  .sidebar-list li {
    padding: 8px 18px;
    border-left: none;
    border-bottom: 3px solid transparent;
  }
  .sidebar-list .active {
    border-left: none;
    border-bottom: 3px solid #258aff;
  }
  .main-list {
    padding: 8px 4px 8px 4px;
  }
}
@media (max-width: 600px) {
  .navbar {
    flex-direction: column;
    height: auto;
    padding: 8px 8px;
  }
  .nav-links {
    flex-direction: column;
    width: 100%;
  }
  .nav-links li {
    margin: 8px 0 0 0;
  }
  .sidebar {
    font-size: 11px;
    padding: 4px 0 0 0;
  }
  .main-list {
    padding: 4px 2px 4px 2px;
  }
}
</style> 